<template>
  <div class="login" @keyup.enter.stop="submit()">
    <div class="picbox">
      <div class="diqiu">
        <img src="../assets/images/login3.png" /><img class="img" src="../assets/images/login2.png" />
      </div>
      <div class="bottom"><img src="../assets/images/login1.png" /></div>
    </div>
    <div class="loginBox">
      <div class="logo">
        <div class="img"><img src="../assets/images/logo1.png" /></div>
        <div class="text">
          综合能源智慧管理平台
          <p>
            让智慧点亮生活
            <span class="mode">演示系统</span>
          </p>
        </div>
        <div class="icon">
          <i v-for="i in 32" :key="i"></i>
        </div>
      </div>
      <div class="form">
        <p>
          <img src="../assets/images/login_user.png" alt="" /><input type="text" v-model="username" />
        </p>
        <p>
          <img src="../assets/images/login_pwd.png" alt="" /><input type="password" v-model="password" />
        </p>
        <p class="check">
          <!-- <el-checkbox v-model="ssh">30天免登录</el-checkbox> -->
          <!-- <router-link to='/findpwd'>找回密码</router-link>
          <router-link to='/register'>注册</router-link> -->
        </p>
        <p>
          <button @click="submit()">登 录</button>
        </p>
      </div>
    </div>
    <div class="footer">
      <a style="color: #fff" href="http://beian.miit.gov.cn" target="_blank">蜀ICP备17018785号-2</a> Copyright &copy;2020<span class="spad"></span>德阳指尖秘码科技有限公司<span class="spad"></span>联系电话：19981032108

    </div>
  </div>
</template>

<script>
import menu from '@/apis/SystemSetting'

import api from '../apis/login'
export default {
  data() {
    return {
      ssh: false,
      sshObj: {
        time: '',
        ssh: false,
      },
      username: '',
      password: '',
    }
  },
  mounted() {
    // if (localStorage.getItem('ssh')) {
    //   let sshObj = JSON.parse(localStorage.getItem('ssh'))
    //   if (sshObj.ssh) {
    //     let startTime = new Date(sshObj.time).getTime()
    //     let nowTime = new Date().getTime()
    //     if (nowTime - startTime < 1000 * 60 * 60 * 24 * 29) {
    //       this.$router.replace('/index/home')
    //       this.$message({
    //         message: '自动登录中！',
    //         type: 'success',
    //         duration: '800',
    //       })
    //     } else {
    //       localStorage.removeItem('ssh')
    //       this.$message({
    //         message: '自动登录已过期！',
    //         type: 'warning',
    //         duration: '1500',
    //       })
    //     }
    //   }
    // }
  },
  watch: {
    $route: {
      handler(to) {
        //自动调用 handler
        // console.log('query',to.query);
        if (
          to.query.token !== undefined &&
          to.query.token !== 'null' &&
          to.query.token != ''
        ) {
          // console.log(to.query.token);
          this.tokenLogin(to.query.token)
          // this.$router.push('/intelligence/workOrder');
        }
      },
      immediate: true, //立刻
    },
  },
  methods: {
    tokenLogin(token) {
      this.username='demo'
      this.password='demo'      
      api
      .Login({ username: token, password: token, client_id: 'e5cd7e4891bf95d1d19206ce24a7b32e'})
      .then((res) => {
        if (res.code===10000) {

          localStorage.setItem('token', res.data.access_token)

          api.getLoginInfo().then((res)=>{
            this.dispose(res)
          })

        }else{
          this.$message.success(res.message)
        }


            
       
      })
    },
    //用户登录
    submit() {
      if (this.username == '') {
        this.$message({
          message: '用户名不能为空！',
          type: 'error',
          duration: '1000',
        })
        return
      } else if (this.password == '') {
        this.$message({
          message: '密码不能为空！',
          type: 'error',
          duration: '1000',
        })
        return
      }

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      api
        .Login({ username: this.username, password: this.password ,clientId: 'e5cd7e4891bf95d1d19206ce24a7b32e',grantType: "password"})
        .then((res) => {

          if (res.code===200) {
            localStorage.setItem('token', res.data.access_token)
            api.getLoginInfo().then((res)=>{
              
              this.dispose(res)
            })
          } else {
            this.dispose(res)
            this.$message.error(res.msg);
          }

        }).finally(()=>{
          loading.close()
        })





    },
    dispose(res) {
      if (res.code === 200) {
        // console.log(res);
        // if (this.ssh) {
        //   //记录登录
        //   this.sshObj.time = new Date().Format('yyyy-MM-dd hh:mm:ss')
        //   this.sshObj.ssh = this.ssh
        //   localStorage.setItem('ssh', JSON.stringify(this.sshObj))
        // }
        this.$message({
          message: '登录成功',
          type: 'success',
          duration: '400',
          onClose: () => {
            localStorage.setItem('user', JSON.stringify({ username: this.username, userid: res.data.userId,}))
            localStorage.setItem('company', JSON.stringify(res.data.company))
            localStorage.removeItem('oemForm')

            // this.$router.replace('/index/home')
            // window.open('/index/home', '/index/home')

            menu.list({
                params: {
                  hidden: 1,
                },
              })
              .then((res) => {
                if (res.code === 10000) {
                  let path = res.data[0].path
                  console.log(path);
                
                  this.$router.replace(path)
                  
                } else {
                  this.$message.error(res.msg)
                }
              })




          },
        })
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: '1000',
          onClose: () => {
            // this.username = ''
            this.password = ''
          },
        })
      }
    },
  },
}
</script>

<style lang="less">
.login {
  height: 100%;
  position: relative;
  overflow: hidden;
  background: url('../assets/images/login_bg.jpg') no-repeat center;
  background-size: 100% 100%;
  .picbox {
    width: 36rem;
    top: 12%;
    overflow: hidden;
    position: absolute;
    left: 15%;
    animation: ii 8s infinite linear 0s;
    .diqiu {
      position: relative;
      z-index: 99;
      margin-bottom: 150px;
      .img {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .bottom {
      position: absolute;
      bottom: 0px; width: 100%;
      z-index: 22;
    }
  }
  .loginBox {
    background: url('../assets/images/loginbg.png') no-repeat center;
    background-size: 100% 100%;
    width: 21rem;
    height: 20rem;
    z-index: 999;
    position: absolute;
    top: 27%;
    right: 25%;
    .logo {
      position: relative;
      height: 6.2rem;
      padding: 20px;
      padding-top: 45px;
      .img {
        display: inline-block;
        width: 3rem;
        vertical-align: middle;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        display: inline-block;
        margin-left: 15px;
        color: #00ccff;
        vertical-align: middle; position: relative; top:-3px;
        font-size: 1.2rem;
        p {
          font-family: 'ywsf';
          color: #24ffb1;
          font-size: .9rem;
          margin-top: 5px;
          line-height: 25px;
        }
        .mode {
          background: #1c44a9;
          position: relative;
          top: -2px;
          font-size: 12px;
          font-family: Arial, Helvetica, sans-serif;
          color: #fff;
          padding: 5px 6px 4px;
          border-radius: 4px;
          margin-left: 10px;
        }
      }
      .icon {
        position: absolute;
        width: 100%;
        height: .5rem; line-height: 0;
        bottom: 0;
        overflow: hidden;
        animation: aa 6s infinite linear 0s;
        i {
          display: inline-block;
          width: .55rem;
          height: .5rem;
          background: url('../assets/images/z1.png') top no-repeat;
          background-size: 100% 100%;
        }
        i:nth-child(13) {
          opacity: 1;
        }
        i:nth-child(14) {
          opacity: 0.95;
        }
        i:nth-child(15) {
          opacity: 0.9;
        }
        i:nth-child(16) {
          opacity: 0.85;
        }
        i:nth-child(17) {
          opacity: 0.8;
        }
        i:nth-child(18) {
          opacity: 0.75;
        }
        i:nth-child(19) {
          opacity: 0.7;
        }
        i:nth-child(20) {
          opacity: 0.65;
        }
        i:nth-child(21) {
          opacity: 0.6;
        }
        i:nth-child(22) {
          opacity: 0.55;
        }
        i:nth-child(23) {
          opacity: 0.5;
        }
        i:nth-child(24) {
          opacity: 0.45;
        }
        i:nth-child(25) {
          opacity: 0.4;
        }
        i:nth-child(26) {
          opacity: 0.35;
        }
        i:nth-child(27) {
          opacity: 0.3;
        }
        i:nth-child(28) {
          opacity: 0.25;
        }
        i:nth-child(29) {
          opacity: 0.2;
        }
        i:nth-child(30) {
          opacity: 0.15;
        }
        i:nth-child(31) {
          opacity: 0.1;
        }
        i:nth-child(32) {
          opacity: 0.05;
        }
      }
    }
    & > div.form {
      padding: 10px 25px 0px;
      & > p {
        height: 2rem;
        display: flex;
        flex-direction: row;
        margin: 1rem 0;
        img {
          float: left;
          width: 2.1rem;
          height: 1.9rem;
        }
        input {
          height: 1.9rem;
          flex: 1;
          background: transparent;
          border: 1px solid #1c44a9;
          color: #fff;
          font-size: .8rem;
          text-indent: 1rem;
          border-radius: 0 4px 4px 0;
        }
        button {
          width: 100%;
          height: 2.2rem;
          background: #1c44a9;
          border-radius: 4px;
          border: 0;
          color: #fff;
          font-size: 1rem;
          cursor: pointer;
          margin: 0;
        }
        &:last-child {
          margin: 0;
        }
      }
      .check {
        margin: 0;
        font-size: .7rem;
        position: relative;
        .el-checkbox__inner {
          background: transparent;
          border: 1px solid #00ccff;
        }
        .el-checkbox__label {
          color: #00ccff;
        }
        a:first-child {
          position: absolute;
          left: 0;
        }
        a:last-child {
          position: absolute;
          right: 0;
        }
      }
    }
  }
}
@keyframes ii {
  0% {
    transform: translate(0, 0px);
  }
  50% {
    transform: translate(0, 30px);
  }
  100% {
    transform: translate(0, 0px);
  }
}
@keyframes aa {
  0% {
    width: 5%;
  }
  50% {
    width: 100%;
  }
  100% {
    width: 5%;
  }
}
.footer {
  position: absolute;
  width: 100%;
  padding: 10px 50px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.8);
  opacity: 0.6;
  bottom: 0px;
}
.footer .left {
  float: left;
  width: 50%;
}
.footer .right {
  float: right;
  text-align: right;
  width: 50%;
}
.footer .spad {
  width: 10px;
  display: inline-block;
}
</style>